import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type StaffRole = 'ADMIN' | 'MANAGER' | 'STAFF';
export type StaffStatus = 'ACTIVE' | 'INACTIVE';

export interface AuthStaff {
  id: string;
  username: string;
  nickname: string;
  role: StaffRole;
  status: StaffStatus;
  email: string | null;
  department: string | null;
  jobTitle: string | null;
  lastLoginAt: string | null;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  staff: AuthStaff | null;
  setAuth: (data: { accessToken: string; refreshToken: string; staff: AuthStaff }) => void;
  setAccessToken: (token: string) => void;
  setStaff: (staff: AuthStaff) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      staff: null,
      setAuth: ({ accessToken, refreshToken, staff }) => set({ accessToken, refreshToken, staff }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setStaff: (staff) => set({ staff }),
      clear: () => set({ accessToken: null, refreshToken: null, staff: null }),
    }),
    { name: 'haha-admin-auth' },
  ),
);
